"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardPerformance = void 0;
/**
 * It holds the standard performance information for a specific standard
 *
 * @author fabian.perez
 */
var StandardPerformance = /** @class */ (function () {
    function StandardPerformance(standardPerformance) {
        if (standardPerformance === void 0) { standardPerformance = {}; }
        Object.assign(this, standardPerformance);
    }
    /**
     * Return the performance for the provided standards performance records
     * @param standardsPerformance
     * @returns { { maxScore: number, score: number } } the overall performance
     */
    StandardPerformance.calculatePerformance = function (standardsPerformance) {
        if (standardsPerformance === void 0) { standardsPerformance = []; }
        var performance = {
            maxScore: 0,
            score: 0,
        };
        standardsPerformance.forEach(function (standardPerformance) {
            if (standardPerformance) {
                var _a = standardPerformance.maxScore, maxScore = _a === void 0 ? 0 : _a, _b = standardPerformance.score, score = _b === void 0 ? 0 : _b;
                performance.maxScore += maxScore;
                performance.score += score;
            }
        });
        return performance;
    };
    /**
     * Return the standards performance within a specific band
     * @param { StandardPerformance[] } standardsPerformance
     * @param { PerformanceBand } band
     * @returns { StandardPerformance[] } the standards
     */
    StandardPerformance.findByPerformanceBand = function (standardsPerformance, band) {
        if (standardsPerformance === void 0) { standardsPerformance = []; }
        return standardsPerformance.filter(function (standardPerformance) {
            return band.inRange(standardPerformance.percentage);
        });
    };
    /**
     * Return the standards performance from a given standard
     * @param {string} standard
     * @param {AssigneeStandardPerformance[]} assigneesStandardPerformance
     * @returns {StandardPerformance[]} the standards performance
     */
    StandardPerformance.findByStandard = function (standard, assigneesStandardPerformance) {
        var standards = [];
        assigneesStandardPerformance.forEach(function (assignee) {
            var assigneeStandardPerformance = assignee.standardPerformanceByStandard(standard);
            if (assigneeStandardPerformance) {
                standards.push(assigneeStandardPerformance);
            }
        });
        return standards;
    };
    return StandardPerformance;
}());
exports.StandardPerformance = StandardPerformance;
